import { render, staticRenderFns } from "./MoreInformation.vue?vue&type=template&id=c23d4bca&scoped=true"
import script from "./MoreInformation.vue?vue&type=script&lang=js"
export * from "./MoreInformation.vue?vue&type=script&lang=js"
import style0 from "./MoreInformation.vue?vue&type=style&index=0&id=c23d4bca&prod&lang=css"
import style1 from "./MoreInformation.vue?vue&type=style&index=1&id=c23d4bca&prod&scoped=true&lang=css"
import style2 from "./MoreInformation.vue?vue&type=style&index=2&id=c23d4bca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c23d4bca",
  null
  
)

export default component.exports